import React, { useState } from "react";
import { Modal } from "@/components/Layout";
import api from "@/lib/api";
import { MONTHS } from "./TimeentriesFilters";
import Select from "@/components/Select";

export default function TimeentriesExportDialog({ filters, structures, visibleIds = [], onClose }) {
  const thisYear = new Date().getFullYear();
  const [year, setYear] = useState(filters.year);
  const [month, setMonth] = useState(filters.month);
  const [format, setFormat] = useState("xlsx");
  const [structureId, setStructureId] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const download = async () => {
    setBusy(true); setError("");
    try {
      const params = { year, month, format };
      if (structureId) params.structure_id = structureId;
      // rapoartele alese în filtre se păstrează în export (ID-uri separate prin virgulă)
      if (visibleIds.length) params.employment_ids = visibleIds.join(",");
      const r = await api.get("/timeentries/export", { params });
      // navigare directă: cookie-ul de sesiune se trimite, răspunsul e attachment
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}${r.data.download_url}`;
      onClose();
    } catch (e) {
      setError(e?.response?.data?.detail || "Exportul a eșuat");
    } finally { setBusy(false); }
  };

  return (
    <Modal title="Export pontaj" onClose={onClose} width={520}>
      <div className="grid-2">
        <div><label className="label">Lună</label>
          <Select className="select" value={month} onChange={e => setMonth(Number(e.target.value))} data-testid="te-export-month">
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </Select></div>
        <div><label className="label">An</label>
          <Select className="select" value={year} onChange={e => setYear(Number(e.target.value))} data-testid="te-export-year">
            {[thisYear - 1, thisYear, thisYear + 1].map(y => <option key={y} value={y}>{y}</option>)}
          </Select></div>
        <div><label className="label">Format</label>
          <Select className="select" value={format} onChange={e => setFormat(e.target.value)} data-testid="te-export-format">
            <option value="xlsx">Excel (XLSX)</option><option value="csv">CSV</option>
          </Select></div>
        <div><label className="label">Structură</label>
          <Select className="select" value={structureId} onChange={e => setStructureId(e.target.value)} data-testid="te-export-structure">
            <option value="">Toate</option>
            {structures.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </Select></div>
      </div>
      {visibleIds.length > 0 && (
        <div style={{ fontSize: 12, color: "#64748B", marginTop: 10 }}>
          Se exportă doar cele {visibleIds.length} rapoarte de muncă rămase după filtrele aplicate.
        </div>
      )}
      {error && <div style={{ color: "#991B1B", fontSize: 13, marginTop: 10 }} data-testid="te-export-error">{error}</div>}
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
        <button className="btn btn-secondary" onClick={onClose}>Anulează</button>
        <button className="btn btn-primary" disabled={busy} onClick={download} data-testid="te-export-download">Descarcă</button>
      </div>
    </Modal>
  );
}
